export default "__VITE_ASSET__DOtwQXom__"